export default __webpack_public_path__ + "static/media/roundel_dt@2x.9b06b3b1.png";